module.exports = __webpack_public_path__ + "static/media/edit-disabled.24990f19.svg";